var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 12v2H0v-2zM7 0v6.634L8.5 4.5h.508c.55 0 .992.444.992.993V6L6.679 9.654a.897.897 0 0 1-1.358 0L2 6v-.508c0-.55.444-.993.992-.993H3.5L5 6.634V0z"
})));
export default SvgDownload;